// The scroll a navigation asks for, set by scrollBehavior in router.js and
// carried out once the new page is in place: by App.vue after the route
// transition, or by Help.vue between help pages (which share one component,
// so there is no transition). Kept apart from router.js so views can read it
// without importing the router.
let pendingScrollIntent = null;

export function setPendingScrollIntent(intent) {
  pendingScrollIntent = intent;
}

export function getPendingScrollIntent() {
  return pendingScrollIntent;
}

export function clearPendingScrollIntent() {
  pendingScrollIntent = null;
}
